import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { dotConverter } from 'Utils/converters';
import EnvironmentManager from '../../../../../utils/environmentManager';

import {
  EMPTY,
  INCREASE,
  DECREASE,
  BLOCK
} from 'Store/constants/sportTypes';
import { useSelector } from 'react-redux';


const BetPillHorizontal = ({ pillType, currentOddsWeb, betType, tWinOdd, isSystem, odd, percentage, rateChange, onClick, isSelected, highlightOdd, oddType, loginStatus, hasTopWin, isSuspended }) => {
  const pillClass = classnames({
    'bet-pill': true,
    'bet-pill--horizontal': true,
    'bet-pill--horizontal--active': isSelected,
    'bet-pill--horizontal--empty': pillType === EMPTY,
    'bet-pill--horizontal--one-hnd': pillType === 'one-hnd',
    'bet-pill--horizontal--two-hnd': pillType === 'two-hnd',
    'bet-pill--horizontal--block': pillType === BLOCK,
    'bet-pill--increase': rateChange === INCREASE,
    'bet-pill--decrease': rateChange === DECREASE,
    'bet-pill--horizontal--suspended': !!isSuspended
  });

  const oddClass = classnames({
    'bet-pill__odd': true,
    'bet-pill__odd--highlight--decrease': highlightOdd === 1,
    'bet-pill__odd--highlight--increase': highlightOdd === 2
  });

  const blurryClass = loginStatus === false ? ' blurry-text' : '';
  const zirveOranSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_switch' }) == 'true';
  const { topWinEnabled } = useSelector(state => state?.auth?.data);
  const isHtw = hasTopWin !== undefined ? hasTopWin : topWinEnabled;

  // eslint-disable-next-line no-nested-ternary
  let oddRow = pillType === 'empty'
    ? (<div className={ 'bet-pill__odd bet-pill__odd--inactive' + blurryClass } />)
    : ( zirveOranSwitch && isHtw && tWinOdd > odd && !isSystem && !currentOddsWeb
      ?  <>
        <span className={ 'bet-pill__odd--old-value ' + oddClass + blurryClass }> { dotConverter(odd, oddType) } </span>
        <div className='bet-pill__odd--zirve-oran'> { dotConverter(tWinOdd, oddType) }</div>
        </>
      :  <div className={ oddClass + blurryClass }>{ dotConverter(odd, oddType) }</div>
    );
  let horizontalPill;

  if (pillType === BLOCK) {
    horizontalPill = (
      <div className={ pillClass } onClick={ onClick }>
        <div className={ 'bet-pill__label ' + blurryClass }>{ betType }</div>
        { oddRow }
        { percentage && <div className={ 'bet-pill__percentage' + blurryClass }>%{ percentage }</div> }
      </div>
    );
  } else {
    horizontalPill = (
      <div className={ 'bet-pill ' + pillClass } onClick={ onClick }>
        <div className={ 'bet-pill__bet-type' + blurryClass }>{ betType }</div>
        { oddRow }
      </div>
    );
  }

  return horizontalPill;
};

BetPillHorizontal.propTypes = {
  pillType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  betType: PropTypes.string,
  label: PropTypes.string,
  odd: PropTypes.any,
  percentage: PropTypes.string,
  rateChange: PropTypes.number,
  highlightOdd: PropTypes.bool,
  isSuspended: PropTypes.bool
};

export default BetPillHorizontal;
